module.exports = __webpack_public_path__ + "img/icn_scarpa_edit_2.3b4ad3f3.png";